'use strict';
import React, { PureComponent } from 'react';
import TimelineSaldos from "../../../Common/Components/HorizontalTimeline/src/Components/TimelineSaldos"
import Header from "./CuentaCorriente/Header";
import Resumen from "./CuentaCorriente/Resumen";
import Tarjeta from "./CuentaCorriente/Tarjeta";
import Footer from "./CuentaCorriente/Footer";

class CuentaCorriente extends PureComponent {

    constructor(props) {
        super(props);
        // TODO: es necesario el state?
        this.state = { value: 0, previous: 0, modalTotalCuotasPendientes: false, cargando: false };
    }

    componentDidMount() {
        this.props.getCuentaCorrienteData(this.props.cuentaTarjetaId, null);
    }

    toggleTotalCuotasPendientes() {
        this.setState({ modalTotalCuotasPendientes: !this.state.modalTotalCuotasPendientes });
    }

    componentWillReceiveProps(nextProps) {
        this.setState({ cargando: false });
    }

    render() {
        let componentesCC = null;

        const { saldosResumenes } = this.props;
        const { cuentaCorriente, modalTotalCuotasPendientes } = saldosResumenes;


        if (!cuentaCorriente)
            return null;

        const { detalleCC, consumosTarjetas, extensiones, fechasCierreCC, montoTotales, cuotasPendientesTotales,
            cuotasPendientes, cuotasPendientesDolares, cuotasPendientesPesos, totalCuotasPendientesDolares, totalCuotasPendientesPesos,
            fechasCierresConsumos, tarjetasCreditoId } = cuentaCorriente;

        componentesCC = fechasCierreCC.map((fcc, index) => {

            const resumen = detalleCC.filter(x => x.CuentaTarjetaSaldoId == fcc.Id && x.FechaHoy == false);
            const resumenHoy = detalleCC.filter(x => x.CuentaTarjetaSaldoId == fcc.Id && x.FechaHoy == true);
            const consumos = consumosTarjetas.filter(x => x.CuentaTarjetaSaldoId == fcc.Id);
            const montos = montoTotales.filter(x => x.CuentaTarjetaSaldoId == fcc.Id);
            const cuotasPendientes = cuotasPendientesTotales.filter(x => x.CuentaTarjetaSaldoId == fcc.Id);
            let fecha = fcc.FechaHoy ? true : false;

            const componente = (
                <div className="col-xs-12" key={index}>

                    <div className="bottom-separator-xs">
                        <Header data={fcc} />
                    </div>
                    {(fcc.FechaHoy) ?
                        <Resumen data={fcc} resumen={resumenHoy} /> :
                        <Resumen data={fcc} resumen={resumen} />
                    }

                    {/*iterar tantas veces como tarjetas tenga*/}
                    {extensiones.filter(e => e.CuentaTarjetaSaldoId == fcc.Id).map((ext, index) => {
                        return <Tarjeta
                            extension={ext}
                            index={index}
                            key={index}
                            consumosTarjetas={consumos.filter(x => x.TarjetaCreditoId == ext.Id && x.FechaHoy == fecha)}
                            montoTotales={montos.filter(x => x.TarjetaCreditoId == ext.Id && x.FechaHoy == fecha)}
                        />
                    })}
                    {/*fin iteracion*/}
                    <Footer
                        getCuotasPendientes={this.props.getCuotasPendientes}
                        cuentaTarjetaId={saldosResumenes.cuenta.Id}
                        data={fcc}
                        resumen={fcc.FechaHoy ? resumenHoy : resumen}
                        montoTotales={montos.filter(x => x.FechaHoy == fecha)}
                        consumosTarjetas={consumos}
                        cuotasPendientesTotales={cuotasPendientes.filter(x => x.FechaHoy == fecha)}
                    />
                </div>
            );

            return {
                date: fcc.FechaCierre,
                fcc,
                component: componente
            };

        });

        const componentesCCSort = componentesCC.sort(function (a, b) { return a.date - b.date });
        return (
            <div>
                {this.state.cargando && <div className="loading">Loading &#8230;</div>}
                <TimelineSaldos content={componentesCCSort} cargarDatosFn={(fecha) => {
                    this.setState({ cargando: true });
                    this.props.getCuentaCorrienteData(this.props.cuentaTarjetaId, fecha, true)
                }} />
            </div>
        );

    }

}

export default CuentaCorriente;